// @ts-nocheck
import { useEffect, useRef, useState, useMemo } from "react";

import { mapCenter } from "../../state/atom/generic";
import { gisFeatureLayerFilter } from "../../state/atom/gis";
import { useRecoilValue } from "recoil";
import { forceRender } from "../../state/atom/report";
import { Link } from "react-router-dom";
import { getUserDetails } from "../../utility/jwt";
import { JwtPayLoad } from "../../shared/jwt.interface";
import { ROLES } from "../../shared/role.constant";
import { Map, View } from "ol";
import { defaults as defaultControls } from "ol/control";
import { fromLonLat, transformExtent } from "ol/proj";
import TileLayer from "ol/layer/Tile";
import { XYZ } from "ol/source";

export interface Props {
  classList?: string;
  mapHeight?: string;
}
export const ReportMapOL = ({ classList, mapHeight }: Props) => {
  const { user }: JwtPayLoad = getUserDetails();
  const mapCenterPostion = useRecoilValue(mapCenter);
  const mapRef = useRef(null);
  const mapInstance = useRef(null); // The OpenLayers Map object
  const [view, setView] = useState(null);
  const filterRef = useRef(null);
  const [basemaps, setBasemaps] = useState<{ Street: TileLayer; Satellite: TileLayer } | null>(
    null,
  );
  const [activeBasemap, setActiveBasemap] = useState<"Street" | "Satellite">("Satellite");
  const gisFeatureLayerFilterData = useRecoilValue(gisFeatureLayerFilter);
  const [isLoading, setIsLoading] = useState(true);

  //Need this line strictly here, otherwise zoom to extent not work
  const forceRenderData = useRecoilValue(forceRender);

  // const createMap = useMemo(
  //   () => async () => {
  //     loadModules([
  //       "esri/Map",
  //       "esri/views/MapView",
  //       "esri/layers/FeatureLayer",
  //       "esri/layers/WebTileLayer",
  //       "esri/widgets/BasemapToggle",
  //       "esri/Basemap",
  //     ])
  //       .then(
  //         ([
  //           Map,
  //           MapView,
  //           FeatureLayer,
  //           WebTileLayer,
  //           BasemapToggle,
  //           Basemap,
  //         ]) => {
  //           const map = new Map({
  //             basemap: mapView,
  //           });

  //           const view = new MapView({
  //             container: mapRef.current,
  //             map: map,
  //             zoom: 6,
  //             center: mapCenterPostion.center,
  //           });
  //           setView(view);

  //           const stateBoundray = new FeatureLayer({
  //             url: process.env.REACT_APP_STATE_BOUNDARY,
  //             outFields: ["*"],
  //           });
  //           map.add(stateBoundray);

  //           const GoogleStreets = new WebTileLayer({
  //             urlTemplate:
  //               "https://mts1.google.com/vt/lyrs=m@186112443&hl=x-local&src=app&x={col}&y={row}&z={level}&s=Galile",
  //             subdomains: ["mt0", "mt1", "mt2", "mt3"],
  //           });
  //           const goglesa = new WebTileLayer({
  //             urlTemplate:
  //               "https://mts1.google.com/vt/lyrs=s@186112443&hl=x-local&src=app&x={col}&y={row}&z={level}&s=Galile",
  //             subdomains: ["mt0", "mt1", "mt2", "mt3"],
  //           });

  //           const gogleSatellite = new WebTileLayer({
  //             urlTemplate:
  //               "https://mt1.google.com/vt/lyrs=s&hl=en&z={level}&x={col}&y={row}",
  //             subdomains: ["mt0", "mt1", "mt2", "mt3"],
  //           });

  //           const googlesate = new Basemap({
  //             baseLayers: [goglesa],
  //             thumbnailUrl: "images/google-hybrid.jpeg",
  //           });
  //           const toggle1 = new BasemapToggle(
  //             {
  //               //titleVisible: false,
  //               view: view,
  //               nextBasemap: googlesate,
  //             },
  //             "goglesat1"
  //           );

  //           const googlestrt = new Basemap({
  //             baseLayers: [GoogleStreets],
  //             thumbnailUrl: "images/google-street.jpeg",
  //           });
  //           const toggle2 = new BasemapToggle(
  //             {
  //               // titleVisible: false,
  //               view: view,
  //               nextBasemap: googlestrt,
  //             },
  //             "goglesat2"
  //           );

  //           const googleSate = new Basemap({
  //             baseLayers: [gogleSatellite],
  //             thumbnailUrl: "images/satellite.jpeg",
  //           });
  //           const toggle3 = new BasemapToggle(
  //             {
  //               // titleVisible: false,
  //               view: view,
  //               nextBasemap: googleSate,
  //             },
  //             "goglesat3"
  //           );

  //           const featureLayer = new FeatureLayer({
  //             url: process.env.REACT_APP_ARC_GIS_URL,
  //             outFields: ["*"],
  //             definitionExpression: "",
  //           });
  //           filterRef.current = featureLayer;
  //           map.add(featureLayer);

  //           featureLayer
  //             .when(() => {
  //               return featureLayer.queryExtent();
  //             })
  //             .then((res) => {
  //               if (res.extent) {
  //                 view.goTo(res.extent).catch(function (error) {
  //                   console.error(error);
  //                 });
  //               }
  //             });
  //         }
  //       )
  //       .catch((error) => {
  //         console.error("Error loading ArcGIS modules:", error);
  //       });
  //   },
  //   [mapCenterPostion.center, mapView]
  // );
  // useEffect(() => {
  //   createMap();
  // }, [createMap]);

  const createMap = useMemo(
    () => async () => {
      console.log("Creating OpenLayers map...");
      const indiaExtent = [68.111378, 6.554607, 97.395561, 35.674545];
      const indiaExtentTransformed = transformExtent(indiaExtent, "EPSG:4326", "EPSG:3857");
      try {
        // Create basemaps
        const streetsBasemap = new TileLayer({
          source: new XYZ({
            url: "https://mt1.google.com/vt/lyrs=m&x={x}&y={y}&z={z}",
            // attributions: "© Google Maps",
          }),
          visible: false,
        });

        const satelliteBasemap = new TileLayer({
          source: new XYZ({
            url: "https://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}",
            // attributions: "© Google Maps",
            crossOrigin: "anonymous",
            tileSize: 256,
          }),
          visible: true,
        });

        // Store layers for switching
        setBasemaps({
          Street: streetsBasemap,
          Satellite: satelliteBasemap,
        });

        // Create view
        const view = new View({
          center: fromLonLat(mapCenterPostion.center || [71.5724, 22.6708]),
          zoom: 2,
          maxZoom: 20,
          minZoom: 5,
          extent: indiaExtentTransformed,
          constrainOnlyCenter: true,
        });
        setView(view); // Store view if needed elsewhere

        // Create map
        const map = new Map({
          target: mapRef.current,
          layers: [satelliteBasemap, streetsBasemap],
          view: view,
          controls: defaultControls({
            attribution: false,
            zoom: true,
            rotate: false,
          }),
        });

        mapInstance.current = map;

        setIsLoading(false);
        console.log("✓ OpenLayers map created successfully!");
      } catch (error) {
        console.error("Error creating OpenLayers map:", error);
        setIsLoading(false);
      }
    },
    [mapCenterPostion.center],
  );

  // Create Map using useEffect
  useEffect(() => {
    createMap();

    // Cleanup function
    return () => {
      if (mapInstance.current) {
        mapInstance.current.setTarget(null);
        mapInstance.current = null;
      }
    };
  }, [createMap]);

  // useEffect(() => {
  //   let definitionExpression = "";
  //   if (user.role === ROLES.abu_spoc) {
  //     definitionExpression = `AND abu_or_lem_user_id='${user.userId}'`;
  //   }
  //   if (user.role === ROLES.le_spoc) {
  //     definitionExpression = `AND le_spoc_user_id='${user.userId}'`;
  //   }
  //   if (user.role === ROLES.le_dh) {
  //     definitionExpression = `AND le_dh_user_id='${user.userId}'`;
  //   }

  //   for (const filter of Object.keys(gisFeatureLayerFilterData)) {
  //     if (gisFeatureLayerFilterData[filter]) {
  //       if (typeof gisFeatureLayerFilterData[filter] == "string") {
  //         definitionExpression += `AND ${filter}='${gisFeatureLayerFilterData[filter]}'`;
  //       } else {
  //         definitionExpression += `AND ${filter}=${gisFeatureLayerFilterData[filter]}`;
  //       }
  //     }
  //   }

  //   if (definitionExpression) {
  //     definitionExpression = definitionExpression.slice(4);
  //   }
  //   if (view) {
  //     if (filterRef.current) {
  //       if (definitionExpression) {
  //         filterRef.current.definitionExpression = definitionExpression;
  //         filterRef.current
  //           .when(() => {
  //             return filterRef.current.queryExtent();
  //           })
  //           .then((res) => {
  //             if (res.extent) {
  //               view.goTo(res.extent).catch(function (error) {
  //                 console.error(error);
  //               });
  //             }
  //           });
  //       } else {
  //         filterRef.current.definitionExpression = "";
  //       }
  //     }
  //   }
  // }, [view, gisFeatureLayerFilterData, forceRenderData, user.role, user.userId]);

  const changeBaseMap = (mapType) => {
    if (!basemaps) return;

    // Hide all base layers
    basemaps.Street.setVisible(false);
    basemaps.Satellite.setVisible(false);

    // Show selected layer
    if (mapType === "Street") {
      basemaps.Street.setVisible(true);
      setActiveBasemap("Street");
    } else {
      basemaps.Satellite.setVisible(true);
      setActiveBasemap("Satellite");
    }
    // console.log(`Switched to ${mapType}`);
  };

  return (
    <div ref={mapRef} id="viewDiv" style={{ height: mapHeight || "100vh" }} className={classList}>
      {/* BaseMap Switch */}
      <div className="map-type">
        <div className="dropdown">
          <div className="nav-item dropdown align-items-center pe-2">
            <Link
              className="nav-link font-weight-bold d-flex text-white dropdown-toggle"
              role="button"
              data-bs-toggle="dropdown"
              to={""}
            >
              <i className="material-icons opacity-10">public</i>
            </Link>
            <ul
              className="dropdown-menu dropdown-menu-end"
              style={{
                minWidth: "90px",
                background: "#0c0c0c85",
              }}
            >
              <li className="map-type-li">
                <button
                  onClick={() => changeBaseMap("Satellite")}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    width: "100%",
                    padding: "8px 12px",
                    background:
                      activeBasemap === "Satellite" ? "rgba(76, 175, 80, 0.3)" : "transparent",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                    color: "white",
                    fontSize: "14px",
                    transition: "all 0.2s",
                  }}
                  onMouseEnter={(e) => {
                    if (activeBasemap !== "Satellite") {
                      e.currentTarget.style.background = "rgba(255,255,255,0.1)";
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (activeBasemap !== "Satellite") {
                      e.currentTarget.style.background = "transparent";
                    }
                  }}
                  title="Satellite"
                >
                  <img
                    src="images/satellite.jpeg"
                    alt="Satellite"
                    width="35"
                    height="35"
                    style={{
                      borderRadius: "3px",
                      border:
                        activeBasemap === "Satellite"
                          ? "2px solid #4CAF50"
                          : "1px solid rgba(255,255,255,0.3)",
                    }}
                  />
                  <span>Satellite</span>
                  {activeBasemap === "Satellite" && (
                    <i
                      className="material-icons"
                      style={{
                        marginLeft: "auto",
                        fontSize: "18px",
                        color: "#4CAF50",
                      }}
                    >
                      check_circle
                    </i>
                  )}
                </button>
              </li>

              <li className="map-type-li" style={{ marginTop: "5px" }}>
                <button
                  onClick={() => changeBaseMap("Street")}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    width: "100%",
                    padding: "8px 12px",
                    background:
                      activeBasemap === "Street" ? "rgba(76, 175, 80, 0.3)" : "transparent",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                    color: "white",
                    fontSize: "14px",
                    transition: "all 0.2s",
                  }}
                  onMouseEnter={(e) => {
                    if (activeBasemap !== "Street") {
                      e.currentTarget.style.background = "rgba(255,255,255,0.1)";
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (activeBasemap !== "Street") {
                      e.currentTarget.style.background = "transparent";
                    }
                  }}
                  title="Street"
                >
                  <img
                    src="images/google-street.jpeg"
                    alt="Street"
                    width="35"
                    height="35"
                    style={{
                      borderRadius: "3px",
                      border:
                        activeBasemap === "Street"
                          ? "2px solid #4CAF50"
                          : "1px solid rgba(255,255,255,0.3)",
                    }}
                  />
                  <span>Street</span>
                  {activeBasemap === "Street" && (
                    <i
                      className="material-icons"
                      style={{
                        marginLeft: "auto",
                        fontSize: "18px",
                        color: "#4CAF50",
                      }}
                    >
                      check_circle
                    </i>
                  )}
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};
